export const tcc_json = [
  {
    "reg": "PAC",
    "region": "Pacific Ocean",
    "total": 40,
    "db": [
      {
        "id": "PF:A",
        "unp": "PF",
        "un": "FR",
        "name": "Austral Islands",
        "short_name": "Austral Islands",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "AU:0",
        "unp": "AU",
        "un": "AU",
        "name": "Australia",
        "short_name": "Australia",
        "rareness": 7,
        "visitors": 3504
      },
      {
        "id": "PG:I",
        "unp": "PG",
        "un": "PG",
        "name": "Bismarck Archipelago (Admiralty Islands, Bougainville, New Britain, New Ireland)",
        "short_name": "Bismarck Archipelago",
        "rareness": 1,
        "visitors": 14
      },
      {
        "id": "NZ-CIT",
        "unp": "NZ",
        "un": "NZ",
        "name": "Chatham Islands",
        "short_name": "Chatham Islands",
        "rareness": 1,
        "visitors": 2
      },
      {
        "id": "CK",
        "unp": "CK",
        "un": "NZ",
        "name": "Cook Islands (Aitutaki, Penrhyn, Rarotonga)",
        "short_name": "Cook Islands",
        "rareness": 3,
        "visitors": 70
      },
      {
        "id": "CL-VS:1",
        "unp": "CL",
        "un": "CL",
        "name": "Easter Island",
        "short_name": "Easter Island",
        "rareness": 4,
        "visitors": 97
      },
      {
        "id": "FJ",
        "unp": "FJ",
        "un": "FJ",
        "name": "Fiji Islands",
        "short_name": "Fiji Islands",
        "rareness": 5,
        "visitors": 463
      },
      {
        "id": "PF:0",
        "unp": "PF",
        "un": "FR",
        "name": "French Polynesia (Gambier, Tahiti, Tuamotu)",
        "short_name": "French Polynesia",
        "rareness": 4,
        "visitors": 219
      },
      {
        "id": "EC-W",
        "unp": "EC",
        "un": "EC",
        "name": "Galapagos Islands",
        "short_name": "Galapagos Islands",
        "rareness": 4,
        "visitors": 181
      },
      {
        "id": "GU",
        "unp": "GU",
        "un": "US",
        "name": "Guam",
        "short_name": "Guam",
        "rareness": 4,
        "visitors": 177
      },
      {
        "id": "US-HI",
        "unp": "US",
        "un": "US",
        "name": "Hawaiian Islands",
        "short_name": "Hawaiian Islands",
        "rareness": 6,
        "visitors": 2272
      },
      {
        "id": "CL-VS:2",
        "unp": "CL",
        "un": "CL",
        "name": "Juan Fernandez Islands (Robinson Crusoe Island)",
        "short_name": "Juan Fernandez Islands",
        "rareness": 1,
        "visitors": 2
      },
      {
        "id": "KI-G",
        "unp": "KI",
        "un": "KI",
        "name": "Kiribati (Gilberts, Tarawa, Ocean Island)",
        "short_name": "Kiribati",
        "rareness": 1,
        "visitors": 10
      },
      {
        "id": "KI:2",
        "unp": "KI",
        "un": "KI",
        "name": "Line/Phoenix Islands (Canton, Christmas, Enderbury, Fanning)",
        "short_name": "Line/Phoenix Islands",
        "rareness": 1,
        "visitors": 13
      },
      {
        "id": "AU:LDH",
        "unp": "AU",
        "un": "AU",
        "name": "Lord Howe Island",
        "short_name": "Lord Howe Island",
        "rareness": 1,
        "visitors": 9
      },
      {
        "id": "PF:M",
        "unp": "PF",
        "un": "FR",
        "name": "Marquesas Islands",
        "short_name": "Marquesas Islands",
        "rareness": 1,
        "visitors": 12
      },
      {
        "id": "MH",
        "unp": "MH",
        "un": "MH",
        "name": "Marshall Islands, Republic of (Eniwetok, Kwajalein, Majuro)",
        "short_name": "Marshall Islands",
        "rareness": 2,
        "visitors": 22
      },
      {
        "id": "FM",
        "unp": "FM",
        "un": "FM",
        "name": "Micronesia, Fed.States of (Caroline Islands, Chuuk, Kosrae, Pohnpei, Yap)",
        "short_name": "Micronesia",
        "rareness": 2,
        "visitors": 27
      },
      {
        "id": "US-UM-71",
        "unp": "UM",
        "un": "US",
        "name": "Midway Island",
        "short_name": "Midway Island",
        "rareness": 1,
        "visitors": 5
      },
      {
        "id": "NR",
        "unp": "NR",
        "un": "NR",
        "name": "Nauru",
        "short_name": "Nauru",
        "rareness": 1,
        "visitors": 9
      },
      {
        "id": "NC",
        "unp": "NC",
        "un": "FR",
        "name": "New Caledonia & Dependencies (L’Île-des-Pins, Loyalty Islands)",
        "short_name": "New Caledonia",
        "rareness": 4,
        "visitors": 160
      },
      {
        "id": "NZ:0",
        "unp": "NZ",
        "un": "NZ",
        "name": "New Zealand",
        "short_name": "New Zealand",
        "rareness": 6,
        "visitors": 1685
      },
      {
        "id": "NU",
        "unp": "NU",
        "un": "NZ",
        "name": "Niue",
        "short_name": "Niue",
        "rareness": 1,
        "visitors": 6
      },
      {
        "id": "NF",
        "unp": "NF",
        "un": "AU",
        "name": "Norfolk Island",
        "short_name": "Norfolk Island",
        "rareness": 1,
        "visitors": 18
      },
      {
        "id": "MP",
        "unp": "MP",
        "un": "US",
        "name": "Northern Marianas (Saipan, Tinian)",
        "short_name": "Northern Marianas",
        "rareness": 3,
        "visitors": 55
      },
      {
        "id": "JP-13:1",
        "unp": "JP",
        "un": "JP",
        "name": "Ogasawara (Bonin, Iwo Jima, Volcano Island)",
        "short_name": "Ogasawara",
        "rareness": 1,
        "visitors": 3
      },
      {
        "id": "PW",
        "unp": "PW",
        "un": "PW",
        "name": "Palau, Republic of",
        "short_name": "Palau",
        "rareness": 2,
        "visitors": 51
      },
      {
        "id": "PG:0",
        "unp": "PG",
        "un": "PG",
        "name": "Papua New Guinea",
        "short_name": "Papua New Guinea",
        "rareness": 3,
        "visitors": 90
      },
      {
        "id": "PN",
        "unp": "PN",
        "un": "GB",
        "name": "Pitcairn Island",
        "short_name": "Pitcairn Island",
        "rareness": 1,
        "visitors": 5
      },
      {
        "id": "JP-47",
        "unp": "JP",
        "un": "JP",
        "name": "Ryukyu Islands (Okinawa)",
        "short_name": "Ryukyu Islands",
        "rareness": 5,
        "visitors": 471
      },
      {
        "id": "WS",
        "unp": "WS",
        "un": "WS",
        "name": "Samoa",
        "short_name": "Samoa",
        "rareness": 3,
        "visitors": 85
      },
      {
        "id": "AS",
        "unp": "AS",
        "un": "US",
        "name": "Samoa, American",
        "short_name": "American Samoa",
        "rareness": 2,
        "visitors": 30
      },
      {
        "id": "SB",
        "unp": "SB",
        "un": "SB",
        "name": "Solomon Islands (Guadalcanal, New Georgia, Tulagi)",
        "short_name": "Solomon Islands",
        "rareness": 2,
        "visitors": 40
      },
      {
        "id": "AU-TAS",
        "unp": "AU",
        "un": "AU",
        "name": "Tasmania",
        "short_name": "Tasmania",
        "rareness": 5,
        "visitors": 529
      },
      {
        "id": "TK",
        "unp": "TK",
        "un": "NZ",
        "name": "Tokelau Islands (Atafu, Fakaofu, Union)",
        "short_name": "Tokelau Islands",
        "rareness": 1,
        "visitors": 1
      },
      {
        "id": "TO",
        "unp": "TO",
        "un": "TO",
        "name": "Tonga (Nukualofa)",
        "short_name": "Tonga",
        "rareness": 3,
        "visitors": 60
      },
      {
        "id": "TV",
        "unp": "TV",
        "un": "TV",
        "name": "Tuvalu (Ellice Island, Funafuti, Vaitapu)",
        "short_name": "Tuvalu",
        "rareness": 1,
        "visitors": 13
      },
      {
        "id": "VU",
        "unp": "VU",
        "un": "VU",
        "name": "Vanuatu (New Hebrides Islands)",
        "short_name": "Vanuatu",
        "rareness": 4,
        "visitors": 171
      },
      {
        "id": "US-UM-79",
        "unp": "UM",
        "un": "US",
        "name": "Wake Island",
        "short_name": "Wake Island",
        "rareness": 1,
        "visitors": 8
      },
      {
        "id": "WF",
        "unp": "WF",
        "un": "FR",
        "name": "Wallis & Futuna Islands",
        "short_name": "Wallis & Futuna Islands",
        "rareness": 1,
        "visitors": 6
      }
    ],
    "timestamp": "1759184887"
  },
  {
    "reg": "NAM",
    "region": "North America",
    "total": 6,
    "db": [
      {
        "id": "US-AK",
        "unp": "US",
        "un": "US",
        "name": "Alaska",
        "short_name": "Alaska",
        "rareness": 6,
        "visitors": 1323
      },
      {
        "id": "CA:0",
        "unp": "CA",
        "un": "CA",
        "name": "Canada",
        "short_name": "Canada",
        "rareness": 7,
        "visitors": 7560
      },
      {
        "id": "MX",
        "unp": "MX",
        "un": "MX",
        "name": "Mexico",
        "short_name": "Mexico",
        "rareness": 7,
        "visitors": 5474
      },
      {
        "id": "CA-PE",
        "unp": "CA",
        "un": "CA",
        "name": "Prince Edward Island",
        "short_name": "Prince Edward Island",
        "rareness": 5,
        "visitors": 407
      },
      {
        "id": "PM",
        "unp": "PM",
        "un": "FR",
        "name": "St. Pierre & Miquelon",
        "short_name": "St. Pierre & Miquelon",
        "rareness": 2,
        "visitors": 27
      },
      {
        "id": "US:0",
        "unp": "US",
        "un": "US",
        "name": "United States (Contiguous)",
        "short_name": "United States",
        "rareness": 7,
        "visitors": 14976
      }
    ]
  },
  {
    "reg": "CAM",
    "region": "Central America",
    "total": 7,
    "db": [
      {
        "id": "BZ",
        "unp": "BZ",
        "un": "BZ",
        "name": "Belize",
        "short_name": "Belize",
        "rareness": 6,
        "visitors": 764
      },
      {
        "id": "CR",
        "unp": "CR",
        "un": "CR",
        "name": "Costa Rica",
        "short_name": "Costa Rica",
        "rareness": 6,
        "visitors": 1412
      },
      {
        "id": "SV",
        "unp": "SV",
        "un": "SV",
        "name": "El Salvador",
        "short_name": "El Salvador",
        "rareness": 4,
        "visitors": 293
      },
      {
        "id": "GT",
        "unp": "GT",
        "un": "GT",
        "name": "Guatemala",
        "short_name": "Guatemala",
        "rareness": 5,
        "visitors": 624
      },
      {
        "id": "HN",
        "unp": "HN",
        "un": "HN",
        "name": "Honduras",
        "short_name": "Honduras",
        "rareness": 5,
        "visitors": 590
      },
      {
        "id": "NI",
        "unp": "NI",
        "un": "NI",
        "name": "Nicaragua",
        "short_name": "Nicaragua",
        "rareness": 4,
        "visitors": 287
      },
      {
        "id": "PA",
        "unp": "PA",
        "un": "PA",
        "name": "Panama",
        "short_name": "Panama",
        "rareness": 6,
        "visitors": 1005
      }
    ]
  },
  {
    "reg": "SAM",
    "region": "South America",
    "total": 14,
    "db": [
      {
        "id": "AR",
        "unp": "AR",
        "un": "AR",
        "name": "Argentina",
        "short_name": "Argentina",
        "rareness": 6,
        "visitors": 1889
      },
      {
        "id": "BO",
        "unp": "BO",
        "un": "BO",
        "name": "Bolivia",
        "short_name": "Bolivia",
        "rareness": 5,
        "visitors": 509
      },
      {
        "id": "BR:0",
        "unp": "BR",
        "un": "BR",
        "name": "Brazil",
        "short_name": "Brazil",
        "rareness": 6,
        "visitors": 2322
      },
      {
        "id": "CL:0",
        "unp": "CL",
        "un": "CL",
        "name": "Chile",
        "short_name": "Chile",
        "rareness": 6,
        "visitors": 1348
      },
      {
        "id": "CO:0",
        "unp": "CO",
        "un": "CO",
        "name": "Colombia",
        "short_name": "Colombia",
        "rareness": 6,
        "visitors": 1382
      },
      {
        "id": "EC:0",
        "unp": "EC",
        "un": "EC",
        "name": "Ecuador",
        "short_name": "Ecuador",
        "rareness": 5,
        "visitors": 645
      },
      {
        "id": "GF",
        "unp": "GF",
        "un": "FR",
        "name": "French Guiana",
        "short_name": "French Guiana",
        "rareness": 3,
        "visitors": 72
      },
      {
        "id": "GY",
        "unp": "GY",
        "un": "GY",
        "name": "Guyana",
        "short_name": "Guyana",
        "rareness": 3,
        "visitors": 79
      },
      {
        "id": "VE-O",
        "unp": "VE",
        "un": "VE",
        "name": "Nueva Esparta (Margarita Island)",
        "short_name": "Nueva Esparta",
        "rareness": 3,
        "visitors": 85
      },
      {
        "id": "PY",
        "unp": "PY",
        "un": "PY",
        "name": "Paraguay",
        "short_name": "Paraguay",
        "rareness": 5,
        "visitors": 436
      },
      {
        "id": "PE",
        "unp": "PE",
        "un": "PE",
        "name": "Peru",
        "short_name": "Peru",
        "rareness": 6,
        "visitors": 1446
      },
      {
        "id": "SR",
        "unp": "SR",
        "un": "SR",
        "name": "Suriname",
        "short_name": "Suriname",
        "rareness": 3,
        "visitors": 80
      },
      {
        "id": "UY",
        "unp": "UY",
        "un": "UY",
        "name": "Uruguay",
        "short_name": "Uruguay",
        "rareness": 6,
        "visitors": 835
      },
      {
        "id": "VE:0",
        "unp": "VE",
        "un": "VE",
        "name": "Venezuela",
        "short_name": "Venezuela",
        "rareness": 5,
        "visitors": 337
      }
    ]
  },
  {
    "reg": "CRB",
    "region": "Caribbean",
    "total": 31,
    "db": [
      {
        "id": "AI",
        "unp": "AI",
        "un": "GB",
        "name": "Anguilla",
        "short_name": "Anguilla",
        "rareness": 4,
        "visitors": 99
      },
      {
        "id": "AG",
        "unp": "AG",
        "un": "AG",
        "name": "Antigua & Barbuda",
        "short_name": "Antigua & Barbuda",
        "rareness": 5,
        "visitors": 379
      },
      {
        "id": "AW",
        "unp": "AW",
        "un": "NL",
        "name": "Aruba",
        "short_name": "Aruba",
        "rareness": 5,
        "visitors": 652
      },
      {
        "id": "BS",
        "unp": "BS",
        "un": "BS",
        "name": "Bahamas",
        "short_name": "Bahamas",
        "rareness": 6,
        "visitors": 1947
      },
      {
        "id": "BB",
        "unp": "BB",
        "un": "BB",
        "name": "Barbados",
        "short_name": "Barbados",
        "rareness": 5,
        "visitors": 580
      },
      {
        "id": "BQ-BO",
        "unp": "BQ",
        "un": "NL",
        "name": "Bonaire",
        "short_name": "Bonaire",
        "rareness": 4,
        "visitors": 162
      },
      {
        "id": "KY",
        "unp": "KY",
        "un": "GB",
        "name": "Cayman Islands",
        "short_name": "Cayman Islands",
        "rareness": 5,
        "visitors": 628
      },
      {
        "id": "CU",
        "unp": "CU",
        "un": "CU",
        "name": "Cuba",
        "short_name": "Cuba",
        "rareness": 6,
        "visitors": 1143
      },
      {
        "id": "CW",
        "unp": "CW",
        "un": "NL",
        "name": "Curacao",
        "short_name": "Curacao",
        "rareness": 5,
        "visitors": 441
      },
      {
        "id": "DM",
        "unp": "DM",
        "un": "DM",
        "name": "Dominica",
        "short_name": "Dominica",
        "rareness": 4,
        "visitors": 200
      },
      {
        "id": "DO",
        "unp": "DO",
        "un": "DO",
        "name": "Dominican Republic",
        "short_name": "Dominican Republic",
        "rareness": 6,
        "visitors": 1566
      },
      {
        "id": "GD",
        "unp": "GD",
        "un": "GD",
        "name": "Grenada & Dependencies (Carriacou, Grenadines)",
        "short_name": "Grenada",
        "rareness": 4,
        "visitors": 232
      },
      {
        "id": "GP",
        "unp": "GP",
        "un": "FR",
        "name": "Guadeloupe & Dependencies (Marie Galante)",
        "short_name": "Guadeloupe",
        "rareness": 4,
        "visitors": 236
      },
      {
        "id": "HT",
        "unp": "HT",
        "un": "HT",
        "name": "Haiti",
        "short_name": "Haiti",
        "rareness": 4,
        "visitors": 304
      },
      {
        "id": "JM",
        "unp": "JM",
        "un": "JM",
        "name": "Jamaica",
        "short_name": "Jamaica",
        "rareness": 6,
        "visitors": 1200
      },
      {
        "id": "MQ",
        "unp": "MQ",
        "un": "FR",
        "name": "Martinique",
        "short_name": "Martinique",
        "rareness": 4,
        "visitors": 304
      },
      {
        "id": "MS",
        "unp": "MS",
        "un": "GB",
        "name": "Montserrat",
        "short_name": "Montserrat",
        "rareness": 2,
        "visitors": 36
      },
      {
        "id": "KN-N",
        "unp": "KN",
        "un": "KN",
        "name": "Nevis",
        "short_name": "Nevis",
        "rareness": 3,
        "visitors": 73
      },
      {
        "id": "PR",
        "unp": "PR",
        "un": "US",
        "name": "Puerto Rico",
        "short_name": "Puerto Rico",
        "rareness": 6,
        "visitors": 1384
      },
      {
        "id": "BQ:SSE",
        "unp": "BQ",
        "un": "NL",
        "name": "Saba & Sint Eustatius",
        "short_name": "Saba & Sint Eustatius",
        "rareness": 2,
        "visitors": 53
      },
      {
        "id": "CO-SAP",
        "unp": "CO",
        "un": "CO",
        "name": "San Andres & Providencia",
        "short_name": "San Andres & Providencia",
        "rareness": 3,
        "visitors": 86
      },
      {
        "id": "SX",
        "unp": "SX",
        "un": "NL",
        "name": "Sint Maarten (Netherlands)",
        "short_name": "Sint Maarten",
        "rareness": 5,
        "visitors": 549
      },
      {
        "id": "BL",
        "unp": "BL",
        "un": "FR",
        "name": "St. Barthélemy",
        "short_name": "St. Barthélemy",
        "rareness": 3,
        "visitors": 89
      },
      {
        "id": "KN-K",
        "unp": "KN",
        "un": "KN",
        "name": "St. Kitts",
        "short_name": "St. Kitts",
        "rareness": 4,
        "visitors": 300
      },
      {
        "id": "LC",
        "unp": "LC",
        "un": "LC",
        "name": "St. Lucia",
        "short_name": "St. Lucia",
        "rareness": 5,
        "visitors": 481
      },
      {
        "id": "MF",
        "unp": "MF",
        "un": "FR",
        "name": "St. Martin (France)",
        "short_name": "St. Martin",
        "rareness": 5,
        "visitors": 375
      },
      {
        "id": "VC",
        "unp": "VC",
        "un": "VC",
        "name": "St. Vincent & the Grenadines",
        "short_name": "St. Vincent & the Grenadines",
        "rareness": 4,
        "visitors": 162
      },
      {
        "id": "TT",
        "unp": "TT",
        "un": "TT",
        "name": "Trinidad & Tobago",
        "short_name": "Trinidad & Tobago",
        "rareness": 4,
        "visitors": 238
      },
      {
        "id": "TC",
        "unp": "TC",
        "un": "GB",
        "name": "Turks & Caicos Islands",
        "short_name": "Turks & Caicos Islands",
        "rareness": 5,
        "visitors": 346
      },
      {
        "id": "VG",
        "unp": "VG",
        "un": "GB",
        "name": "Virgin Islands, British (Tortola, etc.)",
        "short_name": "British Virgin Islands",
        "rareness": 4,
        "visitors": 297
      },
      {
        "id": "VI",
        "unp": "VI",
        "un": "US",
        "name": "Virgin Islands, U.S. (St. Croix, St. John, St. Thomas)",
        "short_name": "U.S. Virgin Islands",
        "rareness": 6,
        "visitors": 694
      }
    ]
  },
  {
    "reg": "ATL",
    "region": "Atlantic Ocean",
    "total": 14,
    "db": [
      {
        "id": "SH-AC",
        "unp": "SH",
        "un": "GB",
        "name": "Ascension",
        "short_name": "Ascension",
        "rareness": 1,
        "visitors": 11
      },
      {
        "id": "PT-20",
        "unp": "PT",
        "un": "PT",
        "name": "Azores Islands",
        "short_name": "Azores Islands",
        "rareness": 5,
        "visitors": 427
      },
      {
        "id": "BM",
        "unp": "BM",
        "un": "GB",
        "name": "Bermuda",
        "short_name": "Bermuda",
        "rareness": 4,
        "visitors": 296
      },
      {
        "id": "ES-CN",
        "unp": "ES",
        "un": "ES",
        "name": "Canary Islands",
        "short_name": "Canary Islands",
        "rareness": 6,
        "visitors": 2382
      },
      {
        "id": "CV",
        "unp": "CV",
        "un": "CV",
        "name": "Cape Verde Islands",
        "short_name": "Cape Verde Islands",
        "rareness": 4,
        "visitors": 266
      },
      {
        "id": "FK",
        "unp": "FK",
        "un": "GB",
        "name": "Falkland Islands",
        "short_name": "Falkland Islands",
        "rareness": 3,
        "visitors": 70
      },
      {
        "id": "FO",
        "unp": "FO",
        "un": "DK",
        "name": "Faroe Islands",
        "short_name": "Faroe Islands",
        "rareness": 4,
        "visitors": 166
      },
      {
        "id": "BR-PE:1",
        "unp": "BR",
        "un": "BR",
        "name": "Fernando de Noronha",
        "short_name": "Fernando de Noronha",
        "rareness": 2,
        "visitors": 40
      },
      {
        "id": "GL",
        "unp": "GL",
        "un": "DK",
        "name": "Greenland (Kalaallit Nunaat)",
        "short_name": "Greenland",
        "rareness": 4,
        "visitors": 126
      },
      {
        "id": "IS",
        "unp": "IS",
        "un": "IS",
        "name": "Iceland",
        "short_name": "Iceland",
        "rareness": 6,
        "visitors": 2100
      },
      {
        "id": "PT-30",
        "unp": "PT",
        "un": "PT",
        "name": "Madeira",
        "short_name": "Madeira",
        "rareness": 6,
        "visitors": 703
      },
      {
        "id": "GS",
        "unp": "GS",
        "un": "GB",
        "name": "South Georgia & the South Sandwich Islands",
        "short_name": "South Georgia & the South Sandwich Islands",
        "rareness": 2,
        "visitors": 19
      },
      {
        "id": "SH-HL",
        "unp": "SH",
        "un": "GB",
        "name": "St. Helena",
        "short_name": "St. Helena",
        "rareness": 1,
        "visitors": 12
      },
      {
        "id": "SH-TA",
        "unp": "SH",
        "un": "GB",
        "name": "Tristan da Cunha",
        "short_name": "Tristan da Cunha",
        "rareness": 1,
        "visitors": 6
      }
    ]
  },
  {
    "reg": "EUR",
    "region": "Europe and Mediterranean",
    "total": 68,
    "db": [
      {
        "id": "AX",
        "unp": "AX",
        "un": "FI",
        "name": "Aland Islands",
        "short_name": "Aland Islands",
        "rareness": 4,
        "visitors": 214
      },
      {
        "id": "AL",
        "unp": "AL",
        "un": "AL",
        "name": "Albania",
        "short_name": "Albania",
        "rareness": 6,
        "visitors": 1388
      },
      {
        "id": "AD",
        "unp": "AD",
        "un": "AD",
        "name": "Andorra",
        "short_name": "Andorra",
        "rareness": 6,
        "visitors": 1147
      },
      {
        "id": "AT",
        "unp": "AT",
        "un": "AT",
        "name": "Austria",
        "short_name": "Austria",
        "rareness": 7,
        "visitors": 9154
      },
      {
        "id": "ES-IB",
        "unp": "ES",
        "un": "ES",
        "name": "Balearic Islands (Ibiza, Mallorca, Minorca)",
        "short_name": "Balearic Islands",
        "rareness": 7,
        "visitors": 3018
      },
      {
        "id": "BY",
        "unp": "BY",
        "un": "BY",
        "name": "Belarus",
        "short_name": "Belarus",
        "rareness": 6,
        "visitors": 1188
      },
      {
        "id": "BE",
        "unp": "BE",
        "un": "BE",
        "name": "Belgium",
        "short_name": "Belgium",
        "rareness": 7,
        "visitors": 7884
      },
      {
        "id": "BA:0",
        "unp": "BA",
        "un": "BA",
        "name": "Bosnia & Herzegovina",
        "short_name": "Bosnia & Herzegovina",
        "rareness": 6,
        "visitors": 1937
      },
      {
        "id": "BG",
        "unp": "BG",
        "un": "BG",
        "name": "Bulgaria",
        "short_name": "Bulgaria",
        "rareness": 7,
        "visitors": 2619
      },
      {
        "id": "FR-20R",
        "unp": "FR",
        "un": "FR",
        "name": "Corsica",
        "short_name": "Corsica",
        "rareness": 6,
        "visitors": 677
      },
      {
        "id": "GR-M",
        "unp": "GR",
        "un": "GR",
        "name": "Crete",
        "short_name": "Crete",
        "rareness": 6,
        "visitors": 1976
      },
      {
        "id": "HR",
        "unp": "HR",
        "un": "HR",
        "name": "Croatia",
        "short_name": "Croatia",
        "rareness": 7,
        "visitors": 5037
      },
      {
        "id": "XD",
        "unp": "XD",
        "un": "GB",
        "name": "Cyprus, British Sovereign Base Areas of Akrotiri & Dhekelia",
        "short_name": "Cyprus, British Sovereign Base Areas of Akrotiri & Dhekelia",
        "rareness": 3,
        "visitors": 87
      },
      {
        "id": "CY",
        "unp": "CY",
        "un": "CY",
        "name": "Cyprus, Republic",
        "short_name": "Cyprus, Republic",
        "rareness": 6,
        "visitors": 1893
      },
      {
        "id": "XC",
        "unp": "XC",
        "un": "CY",
        "name": "Cyprus, Turkish Fed. State",
        "short_name": "Cyprus, Turkish Fed. State",
        "rareness": 5,
        "visitors": 634
      },
      {
        "id": "CZ",
        "unp": "CZ",
        "un": "CZ",
        "name": "Czech Republic",
        "short_name": "Czech Republic",
        "rareness": 7,
        "visitors": 7812
      },
      {
        "id": "DK",
        "unp": "DK",
        "un": "DK",
        "name": "Denmark",
        "short_name": "Denmark",
        "rareness": 7,
        "visitors": 5304
      },
      {
        "id": "GB-ENG",
        "unp": "GB",
        "un": "GB",
        "name": "England",
        "short_name": "England",
        "rareness": 7,
        "visitors": 12496
      },
      {
        "id": "EE",
        "unp": "EE",
        "un": "EE",
        "name": "Estonia",
        "short_name": "Estonia",
        "rareness": 7,
        "visitors": 2568
      },
      {
        "id": "FI",
        "unp": "FI",
        "un": "FI",
        "name": "Finland",
        "short_name": "Finland",
        "rareness": 7,
        "visitors": 3465
      },
      {
        "id": "FR:0",
        "unp": "FR",
        "un": "FR",
        "name": "France",
        "short_name": "France",
        "rareness": 7,
        "visitors": 14173
      },
      {
        "id": "DE",
        "unp": "DE",
        "un": "DE",
        "name": "Germany",
        "short_name": "Germany",
        "rareness": 7,
        "visitors": 12840
      },
      {
        "id": "GI",
        "unp": "GI",
        "un": "GB",
        "name": "Gibraltar",
        "short_name": "Gibraltar",
        "rareness": 6,
        "visitors": 1241
      },
      {
        "id": "GR:0",
        "unp": "GR",
        "un": "GR",
        "name": "Greece",
        "short_name": "Greece",
        "rareness": 7,
        "visitors": 5586
      },
      {
        "id": "GR:A",
        "unp": "GR",
        "un": "GR",
        "name": "Greek Aegean Islands (Cyclades, Dodecanese, Northern Aegean Islands)",
        "short_name": "Greek Aegean Islands",
        "rareness": 7,
        "visitors": 3211
      },
      {
        "id": "GG",
        "unp": "GG",
        "un": "GB",
        "name": "Guernsey & Dependencies (Alderney, Herm, Sark)",
        "short_name": "Guernsey",
        "rareness": 4,
        "visitors": 163
      },
      {
        "id": "HU",
        "unp": "HU",
        "un": "HU",
        "name": "Hungary",
        "short_name": "Hungary",
        "rareness": 7,
        "visitors": 6232
      },
      {
        "id": "GR-F",
        "unp": "GR",
        "un": "GR",
        "name": "Ionian Islands (Corfu, etc.)",
        "short_name": "Ionian Islands",
        "rareness": 6,
        "visitors": 1635
      },
      {
        "id": "IE",
        "unp": "IE",
        "un": "IE",
        "name": "Ireland (Eire)",
        "short_name": "Ireland",
        "rareness": 7,
        "visitors": 4780
      },
      {
        "id": "GB-NIR",
        "unp": "GB",
        "un": "GB",
        "name": "Ireland, Northern",
        "short_name": "Ireland, Northern",
        "rareness": 6,
        "visitors": 1751
      },
      {
        "id": "IM",
        "unp": "IM",
        "un": "GB",
        "name": "Isle of Man",
        "short_name": "Isle of Man",
        "rareness": 4,
        "visitors": 179
      },
      {
        "id": "IT:0",
        "unp": "IT",
        "un": "IT",
        "name": "Italy",
        "short_name": "Italy",
        "rareness": 7,
        "visitors": 13483
      },
      {
        "id": "JE",
        "unp": "JE",
        "un": "GB",
        "name": "Jersey",
        "short_name": "Jersey",
        "rareness": 4,
        "visitors": 244
      },
      {
        "id": "RU-KGD",
        "unp": "RU",
        "un": "RU",
        "name": "Kaliningrad",
        "short_name": "Kaliningrad",
        "rareness": 6,
        "visitors": 657
      },
      {
        "id": "XK",
        "unp": "XK",
        "un": "RS",
        "name": "Kosovo",
        "short_name": "Kosovo",
        "rareness": 5,
        "visitors": 650
      },
      {
        "id": "IT:LMP",
        "unp": "IT",
        "un": "IT",
        "name": "Lampedusa",
        "short_name": "Lampedusa",
        "rareness": 2,
        "visitors": 22
      },
      {
        "id": "LV",
        "unp": "LV",
        "un": "LV",
        "name": "Latvia",
        "short_name": "Latvia",
        "rareness": 6,
        "visitors": 2215
      },
      {
        "id": "LI",
        "unp": "LI",
        "un": "LI",
        "name": "Liechtenstein",
        "short_name": "Liechtenstein",
        "rareness": 6,
        "visitors": 1172
      },
      {
        "id": "LT",
        "unp": "LT",
        "un": "LT",
        "name": "Lithuania",
        "short_name": "Lithuania",
        "rareness": 6,
        "visitors": 1888
      },
      {
        "id": "LU",
        "unp": "LU",
        "un": "LU",
        "name": "Luxembourg",
        "short_name": "Luxembourg",
        "rareness": 7,
        "visitors": 2769
      },
      {
        "id": "MT",
        "unp": "MT",
        "un": "MT",
        "name": "Malta",
        "short_name": "Malta",
        "rareness": 6,
        "visitors": 1951
      },
      {
        "id": "MD",
        "unp": "MD",
        "un": "MD",
        "name": "Moldova",
        "short_name": "Moldova",
        "rareness": 5,
        "visitors": 506
      },
      {
        "id": "MC",
        "unp": "MC",
        "un": "MC",
        "name": "Monaco",
        "short_name": "Monaco",
        "rareness": 7,
        "visitors": 3508
      },
      {
        "id": "ME",
        "unp": "ME",
        "un": "ME",
        "name": "Montenegro",
        "short_name": "Montenegro",
        "rareness": 6,
        "visitors": 2203
      },
      {
        "id": "NL",
        "unp": "NL",
        "un": "NL",
        "name": "Netherlands",
        "short_name": "Netherlands",
        "rareness": 7,
        "visitors": 10084
      },
      {
        "id": "MK",
        "unp": "MK",
        "un": "MK",
        "name": "North Macedonia",
        "short_name": "North Macedonia",
        "rareness": 6,
        "visitors": 1253
      },
      {
        "id": "NO",
        "unp": "NO",
        "un": "NO",
        "name": "Norway",
        "short_name": "Norway",
        "rareness": 7,
        "visitors": 3629
      },
      {
        "id": "PL",
        "unp": "PL",
        "un": "PL",
        "name": "Poland",
        "short_name": "Poland",
        "rareness": 7,
        "visitors": 5699
      },
      {
        "id": "PT:0",
        "unp": "PT",
        "un": "PT",
        "name": "Portugal",
        "short_name": "Portugal",
        "rareness": 7,
        "visitors": 6721
      },
      {
        "id": "RO",
        "unp": "RO",
        "un": "RO",
        "name": "Romania",
        "short_name": "Romania",
        "rareness": 7,
        "visitors": 2469
      },
      {
        "id": "RU:E",
        "unp": "RU",
        "un": "RU",
        "name": "Russia in Europe",
        "short_name": "Russia in Europe",
        "rareness": 7,
        "visitors": 3612
      },
      {
        "id": "SM",
        "unp": "SM",
        "un": "SM",
        "name": "San Marino",
        "short_name": "San Marino",
        "rareness": 6,
        "visitors": 1227
      },
      {
        "id": "IT-88",
        "unp": "IT",
        "un": "IT",
        "name": "Sardinia",
        "short_name": "Sardinia",
        "rareness": 6,
        "visitors": 1109
      },
      {
        "id": "GB-SCT",
        "unp": "GB",
        "un": "GB",
        "name": "Scotland",
        "short_name": "Scotland",
        "rareness": 7,
        "visitors": 4963
      },
      {
        "id": "RS",
        "unp": "RS",
        "un": "RS",
        "name": "Serbia",
        "short_name": "Serbia",
        "rareness": 6,
        "visitors": 2335
      },
      {
        "id": "IT-82:1",
        "unp": "IT",
        "un": "IT",
        "name": "Sicily",
        "short_name": "Sicily",
        "rareness": 6,
        "visitors": 2382
      },
      {
        "id": "SK",
        "unp": "SK",
        "un": "SK",
        "name": "Slovakia",
        "short_name": "Slovakia",
        "rareness": 7,
        "visitors": 3676
      },
      {
        "id": "SI",
        "unp": "SI",
        "un": "SI",
        "name": "Slovenia",
        "short_name": "Slovenia",
        "rareness": 7,
        "visitors": 3100
      },
      {
        "id": "ES:0",
        "unp": "ES",
        "un": "ES",
        "name": "Spain",
        "short_name": "Spain",
        "rareness": 7,
        "visitors": 11836
      },
      {
        "id": "SJ",
        "unp": "SJ",
        "un": "NO",
        "name": "Spitsbergen (Svalbard, Bear Island)",
        "short_name": "Spitsbergen",
        "rareness": 4,
        "visitors": 121
      },
      {
        "id": "BA-SRP",
        "unp": "BA",
        "un": "BA",
        "name": "Srpska",
        "short_name": "Srpska",
        "rareness": 5,
        "visitors": 631
      },
      {
        "id": "SE",
        "unp": "SE",
        "un": "SE",
        "name": "Sweden",
        "short_name": "Sweden",
        "rareness": 7,
        "visitors": 5332
      },
      {
        "id": "CH",
        "unp": "CH",
        "un": "CH",
        "name": "Switzerland",
        "short_name": "Switzerland",
        "rareness": 7,
        "visitors": 7675
      },
      {
        "id": "XT",
        "unp": "XT",
        "un": "MD",
        "name": "Transnistria (Pridnestrovie)",
        "short_name": "Transnistria",
        "rareness": 4,
        "visitors": 226
      },
      {
        "id": "TR:E",
        "unp": "TR",
        "un": "TR",
        "name": "Turkey in Europe (Istanbul)",
        "short_name": "Turkey in Europe",
        "rareness": 7,
        "visitors": 5259
      },
      {
        "id": "UA",
        "unp": "UA",
        "un": "UA",
        "name": "Ukraine",
        "short_name": "Ukraine",
        "rareness": 6,
        "visitors": 1938
      },
      {
        "id": "VA",
        "unp": "VA",
        "un": "VA",
        "name": "Vatican City",
        "short_name": "Vatican City",
        "rareness": 7,
        "visitors": 5026
      },
      {
        "id": "GB-WLS",
        "unp": "GB",
        "un": "GB",
        "name": "Wales",
        "short_name": "Wales",
        "rareness": 6,
        "visitors": 2465
      }
    ]
  },
  {
    "reg": "ANT",
    "region": "Antarctica",
    "total": 7,
    "db": [
      {
        "id": "AQ:AR",
        "unp": "AQ",
        "un": "AQ",
        "name": "Argentine Antarctica (Antarctic Peninsula)",
        "short_name": "Argentine Antarctica",
        "rareness": 3,
        "visitors": 60
      },
      {
        "id": "AQ:AU",
        "unp": "AQ",
        "un": "AQ",
        "name": "Australian Antarctic Territory (Davis, Heard, Macquarie, Mawson)",
        "short_name": "Australian Antarctic Territory",
        "rareness": 1,
        "visitors": 5
      },
      {
        "id": "AQ:GB",
        "unp": "AQ",
        "un": "AQ",
        "name": "British Antarctic Territory (Antarctic Peninsula, Graham Land, South Orkney, South Shetland)",
        "short_name": "British Antarctic Territory",
        "rareness": 3,
        "visitors": 60
      },
      {
        "id": "AQ:CL",
        "unp": "AQ",
        "un": "AQ",
        "name": "Chilean Antarctic Territory (Antarctic Peninsula)",
        "short_name": "Chilean Antarctic Territory",
        "rareness": 3,
        "visitors": 55
      },
      {
        "id": "AQ:FR",
        "unp": "AQ",
        "un": "AQ",
        "name": "French Antarctica (Adélie, Kerguelen)",
        "short_name": "French Antarctica",
        "rareness": 1,
        "visitors": 4
      },
      {
        "id": "AQ:NZ",
        "unp": "AQ",
        "un": "AQ",
        "name": "New Zealand Antarctica (Ross Dependency)",
        "short_name": "New Zealand Antarctica",
        "rareness": 1,
        "visitors": 7
      },
      {
        "id": "AQ:NO",
        "unp": "AQ",
        "un": "AQ",
        "name": "Norwegian Dependencies (Bouvet, Peter I Island, Queen Maud Land)",
        "short_name": "Norwegian Dependencies (Bouvet, Peter I Island, Queen Maud Land)",
        "rareness": 1,
        "visitors": 4
      }
    ]
  },
  {
    "reg": "AFR",
    "region": "Africa",
    "total": 55,
    "db": [
      {
        "id": "DZ",
        "unp": "DZ",
        "un": "DZ",
        "name": "Algeria",
        "short_name": "Algeria",
        "rareness": 4,
        "visitors": 275
      },
      {
        "id": "AO:0",
        "unp": "AO",
        "un": "AO",
        "name": "Angola",
        "short_name": "Angola",
        "rareness": 4,
        "visitors": 115
      },
      {
        "id": "BJ",
        "unp": "BJ",
        "un": "BJ",
        "name": "Benin",
        "short_name": "Benin",
        "rareness": 3,
        "visitors": 73
      },
      {
        "id": "BW",
        "unp": "BW",
        "un": "BW",
        "name": "Botswana",
        "short_name": "Botswana",
        "rareness": 4,
        "visitors": 290
      },
      {
        "id": "BF",
        "unp": "BF",
        "un": "BF",
        "name": "Burkina Faso",
        "short_name": "Burkina Faso",
        "rareness": 2,
        "visitors": 47
      },
      {
        "id": "BI",
        "unp": "BI",
        "un": "BI",
        "name": "Burundi",
        "short_name": "Burundi",
        "rareness": 2,
        "visitors": 44
      },
      {
        "id": "AO-CAB",
        "unp": "AO",
        "un": "AO",
        "name": "Cabinda",
        "short_name": "Cabinda",
        "rareness": 1,
        "visitors": 10
      },
      {
        "id": "CM",
        "unp": "CM",
        "un": "CM",
        "name": "Cameroon",
        "short_name": "Cameroon",
        "rareness": 3,
        "visitors": 96
      },
      {
        "id": "CF",
        "unp": "CF",
        "un": "CF",
        "name": "Central African Republic",
        "short_name": "Central African Republic",
        "rareness": 2,
        "visitors": 29
      },
      {
        "id": "TD",
        "unp": "TD",
        "un": "TD",
        "name": "Chad",
        "short_name": "Chad",
        "rareness": 2,
        "visitors": 29
      },
      {
        "id": "CD",
        "unp": "CD",
        "un": "CD",
        "name": "Congo, Democratic Republic of (Kinshasa)",
        "short_name": "Congo",
        "rareness": 4,
        "visitors": 106
      },
      {
        "id": "CG",
        "unp": "CG",
        "un": "CG",
        "name": "Congo, Republic of (Brazzaville)",
        "short_name": "Congo",
        "rareness": 2,
        "visitors": 45
      },
      {
        "id": "CI",
        "unp": "CI",
        "un": "CI",
        "name": "Côte d’Ivoire (Ivory Coast)",
        "short_name": "Côte d’Ivoire",
        "rareness": 4,
        "visitors": 140
      },
      {
        "id": "DJ",
        "unp": "DJ",
        "un": "DJ",
        "name": "Djibouti",
        "short_name": "Djibouti",
        "rareness": 3,
        "visitors": 91
      },
      {
        "id": "EG:0",
        "unp": "EG",
        "un": "EG",
        "name": "Egypt in Africa",
        "short_name": "Egypt in Africa",
        "rareness": 7,
        "visitors": 2721
      },
      {
        "id": "GQ-I",
        "unp": "GQ",
        "un": "GQ",
        "name": "Equatorial Guinea (Bioko)",
        "short_name": "Equatorial Guinea (Bioko)",
        "rareness": 2,
        "visitors": 34
      },
      {
        "id": "GQ-C",
        "unp": "GQ",
        "un": "GQ",
        "name": "Equatorial Guinea (Rio Muni)",
        "short_name": "Equatorial Guinea (Rio Muni)",
        "rareness": 1,
        "visitors": 14
      },
      {
        "id": "ER",
        "unp": "ER",
        "un": "ER",
        "name": "Eritrea",
        "short_name": "Eritrea",
        "rareness": 2,
        "visitors": 35
      },
      {
        "id": "SZ",
        "unp": "SZ",
        "un": "SZ",
        "name": "Eswatini (Swaziland)",
        "short_name": "Eswatini",
        "rareness": 4,
        "visitors": 137
      },
      {
        "id": "ET",
        "unp": "ET",
        "un": "ET",
        "name": "Ethiopia",
        "short_name": "Ethiopia",
        "rareness": 5,
        "visitors": 348
      },
      {
        "id": "GA",
        "unp": "GA",
        "un": "GA",
        "name": "Gabon",
        "short_name": "Gabon",
        "rareness": 3,
        "visitors": 57
      },
      {
        "id": "GM",
        "unp": "GM",
        "un": "GM",
        "name": "Gambia, The",
        "short_name": "Gambia",
        "rareness": 4,
        "visitors": 105
      },
      {
        "id": "GH",
        "unp": "GH",
        "un": "GH",
        "name": "Ghana",
        "short_name": "Ghana",
        "rareness": 4,
        "visitors": 250
      },
      {
        "id": "GN",
        "unp": "GN",
        "un": "GN",
        "name": "Guinea",
        "short_name": "Guinea",
        "rareness": 2,
        "visitors": 52
      },
      {
        "id": "GW",
        "unp": "GW",
        "un": "GW",
        "name": "Guinea-Bissau",
        "short_name": "Guinea-Bissau",
        "rareness": 2,
        "visitors": 34
      },
      {
        "id": "KE",
        "unp": "KE",
        "un": "KE",
        "name": "Kenya",
        "short_name": "Kenya",
        "rareness": 6,
        "visitors": 795
      },
      {
        "id": "LS",
        "unp": "LS",
        "un": "LS",
        "name": "Lesotho",
        "short_name": "Lesotho",
        "rareness": 4,
        "visitors": 116
      },
      {
        "id": "LR",
        "unp": "LR",
        "un": "LR",
        "name": "Liberia",
        "short_name": "Liberia",
        "rareness": 2,
        "visitors": 43
      },
      {
        "id": "LY",
        "unp": "LY",
        "un": "LY",
        "name": "Libya",
        "short_name": "Libya",
        "rareness": 4,
        "visitors": 114
      },
      {
        "id": "MW",
        "unp": "MW",
        "un": "MW",
        "name": "Malawi",
        "short_name": "Malawi",
        "rareness": 3,
        "visitors": 94
      },
      {
        "id": "ML",
        "unp": "ML",
        "un": "ML",
        "name": "Mali",
        "short_name": "Mali",
        "rareness": 3,
        "visitors": 68
      },
      {
        "id": "MR",
        "unp": "MR",
        "un": "MR",
        "name": "Mauritania",
        "short_name": "Mauritania",
        "rareness": 3,
        "visitors": 73
      },
      {
        "id": "MA:0",
        "unp": "MA",
        "un": "MA",
        "name": "Morocco",
        "short_name": "Morocco",
        "rareness": 7,
        "visitors": 2820
      },
      {
        "id": "EA",
        "unp": "ES",
        "un": "ES",
        "name": "Morocco, Spanish (Ceuta, Melilla)",
        "short_name": "Ceuta & Melilla",
        "rareness": 4,
        "visitors": 221
      },
      {
        "id": "MZ",
        "unp": "MZ",
        "un": "MZ",
        "name": "Mozambique",
        "short_name": "Mozambique",
        "rareness": 4,
        "visitors": 221
      },
      {
        "id": "NA",
        "unp": "NA",
        "un": "NA",
        "name": "Namibia",
        "short_name": "Namibia",
        "rareness": 5,
        "visitors": 327
      },
      {
        "id": "NE",
        "unp": "NE",
        "un": "NE",
        "name": "Niger",
        "short_name": "Niger",
        "rareness": 2,
        "visitors": 29
      },
      {
        "id": "NG",
        "unp": "NG",
        "un": "NG",
        "name": "Nigeria",
        "short_name": "Nigeria",
        "rareness": 4,
        "visitors": 267
      },
      {
        "id": "RW",
        "unp": "RW",
        "un": "RW",
        "name": "Rwanda",
        "short_name": "Rwanda",
        "rareness": 4,
        "visitors": 166
      },
      {
        "id": "ST",
        "unp": "ST",
        "un": "ST",
        "name": "Sao Tome & Principe",
        "short_name": "Sao Tome & Principe",
        "rareness": 2,
        "visitors": 51
      },
      {
        "id": "SN",
        "unp": "SN",
        "un": "SN",
        "name": "Senegal",
        "short_name": "Senegal",
        "rareness": 4,
        "visitors": 301
      },
      {
        "id": "SL",
        "unp": "SL",
        "un": "SL",
        "name": "Sierra Leone",
        "short_name": "Sierra Leone",
        "rareness": 3,
        "visitors": 61
      },
      {
        "id": "SO",
        "unp": "SO",
        "un": "SO",
        "name": "Somalia (Italian Somaliland)",
        "short_name": "Somalia",
        "rareness": 2,
        "visitors": 38
      },
      {
        "id": "XS",
        "unp": "XS",
        "un": "SO",
        "name": "Somaliland (British)",
        "short_name": "Somaliland",
        "rareness": 2,
        "visitors": 28
      },
      {
        "id": "ZA",
        "unp": "ZA",
        "un": "ZA",
        "name": "South Africa",
        "short_name": "South Africa",
        "rareness": 6,
        "visitors": 1627
      },
      {
        "id": "SS",
        "unp": "SS",
        "un": "SS",
        "name": "South Sudan",
        "short_name": "South Sudan",
        "rareness": 2,
        "visitors": 29
      },
      {
        "id": "SD",
        "unp": "SD",
        "un": "SD",
        "name": "Sudan",
        "short_name": "Sudan",
        "rareness": 3,
        "visitors": 90
      },
      {
        "id": "TZ:0",
        "unp": "TZ",
        "un": "TZ",
        "name": "Tanzania",
        "short_name": "Tanzania",
        "rareness": 5,
        "visitors": 550
      },
      {
        "id": "TG",
        "unp": "TG",
        "un": "TG",
        "name": "Togo",
        "short_name": "Togo",
        "rareness": 3,
        "visitors": 85
      },
      {
        "id": "TN",
        "unp": "TN",
        "un": "TN",
        "name": "Tunisia",
        "short_name": "Tunisia",
        "rareness": 6,
        "visitors": 1376
      },
      {
        "id": "UG",
        "unp": "UG",
        "un": "UG",
        "name": "Uganda",
        "short_name": "Uganda",
        "rareness": 4,
        "visitors": 240
      },
      {
        "id": "EH:0",
        "unp": "EH",
        "un": "MA",
        "name": "Western Sahara",
        "short_name": "Western Sahara",
        "rareness": 3,
        "visitors": 67
      },
      {
        "id": "ZM",
        "unp": "ZM",
        "un": "ZM",
        "name": "Zambia",
        "short_name": "Zambia",
        "rareness": 4,
        "visitors": 281
      },
      {
        "id": "TZ-Z",
        "unp": "TZ",
        "un": "TZ",
        "name": "Zanzibar",
        "short_name": "Zanzibar",
        "rareness": 5,
        "visitors": 430
      },
      {
        "id": "ZW",
        "unp": "ZW",
        "un": "ZW",
        "name": "Zimbabwe",
        "short_name": "Zimbabwe",
        "rareness": 5,
        "visitors": 323
      }
    ]
  },
  {
    "reg": "MID",
    "region": "Middle East",
    "total": 21,
    "db": [
      {
        "id": "AE-AZ",
        "unp": "AE",
        "un": "AE",
        "name": "Abu Dhabi",
        "short_name": "Abu Dhabi",
        "rareness": 6,
        "visitors": 1883
      },
      {
        "id": "AE-AJ",
        "unp": "AE",
        "un": "AE",
        "name": "Ajman",
        "short_name": "Ajman",
        "rareness": 4,
        "visitors": 99
      },
      {
        "id": "BH",
        "unp": "BH",
        "un": "BH",
        "name": "Bahrain",
        "short_name": "Bahrain",
        "rareness": 5,
        "visitors": 536
      },
      {
        "id": "AE-DU",
        "unp": "AE",
        "un": "AE",
        "name": "Dubai",
        "short_name": "Dubai",
        "rareness": 7,
        "visitors": 3481
      },
      {
        "id": "EG:S",
        "unp": "EG",
        "un": "EG",
        "name": "Egypt in Asia (Sinai Peninsula)",
        "short_name": "Egypt in Asia",
        "rareness": 6,
        "visitors": 892
      },
      {
        "id": "AE-FU",
        "unp": "AE",
        "un": "AE",
        "name": "Fujairah",
        "short_name": "Fujairah",
        "rareness": 4,
        "visitors": 249
      },
      {
        "id": "IR",
        "unp": "IR",
        "un": "IR",
        "name": "Iran",
        "short_name": "Iran",
        "rareness": 5,
        "visitors": 446
      },
      {
        "id": "IQ",
        "unp": "IQ",
        "un": "IQ",
        "name": "Iraq",
        "short_name": "Iraq",
        "rareness": 4,
        "visitors": 272
      },
      {
        "id": "IL",
        "unp": "IL",
        "un": "IL",
        "name": "Israel",
        "short_name": "Israel",
        "rareness": 6,
        "visitors": 1683
      },
      {
        "id": "JO",
        "unp": "JO",
        "un": "JO",
        "name": "Jordan",
        "short_name": "Jordan",
        "rareness": 6,
        "visitors": 1061
      },
      {
        "id": "KW",
        "unp": "KW",
        "un": "KW",
        "name": "Kuwait",
        "short_name": "Kuwait",
        "rareness": 5,
        "visitors": 359
      },
      {
        "id": "LB",
        "unp": "LB",
        "un": "LB",
        "name": "Lebanon",
        "short_name": "Lebanon",
        "rareness": 5,
        "visitors": 520
      },
      {
        "id": "OM",
        "unp": "OM",
        "un": "OM",
        "name": "Oman",
        "short_name": "Oman",
        "rareness": 6,
        "visitors": 758
      },
      {
        "id": "PS",
        "unp": "PS",
        "un": "PS",
        "name": "Palestine",
        "short_name": "Palestine",
        "rareness": 5,
        "visitors": 629
      },
      {
        "id": "QA",
        "unp": "QA",
        "un": "QA",
        "name": "Qatar",
        "short_name": "Qatar",
        "rareness": 6,
        "visitors": 1407
      },
      {
        "id": "AE-RK",
        "unp": "AE",
        "un": "AE",
        "name": "Ras Al Khaimah",
        "short_name": "Ras Al Khaimah",
        "rareness": 4,
        "visitors": 239
      },
      {
        "id": "SA",
        "unp": "SA",
        "un": "SA",
        "name": "Saudi Arabia",
        "short_name": "Saudi Arabia",
        "rareness": 6,
        "visitors": 878
      },
      {
        "id": "AE-SH",
        "unp": "AE",
        "un": "AE",
        "name": "Sharjah",
        "short_name": "Sharjah",
        "rareness": 5,
        "visitors": 500
      },
      {
        "id": "SY",
        "unp": "SY",
        "un": "SY",
        "name": "Syria",
        "short_name": "Syria",
        "rareness": 4,
        "visitors": 275
      },
      {
        "id": "AE-UQ",
        "unp": "AE",
        "un": "AE",
        "name": "Umm Al Qaiwain",
        "short_name": "Umm Al Qaiwain",
        "rareness": 3,
        "visitors": 89
      },
      {
        "id": "YE:0",
        "unp": "YE",
        "un": "YE",
        "name": "Yemen",
        "short_name": "Yemen",
        "rareness": 3,
        "visitors": 68
      }
    ]
  },
  {
    "reg": "IND",
    "region": "Indian Ocean",
    "total": 15,
    "db": [
      {
        "id": "IN-AN",
        "unp": "IN",
        "un": "IN",
        "name": "Andaman-Nicobar Islands",
        "short_name": "Andaman-Nicobar Islands",
        "rareness": 3,
        "visitors": 58
      },
      {
        "id": "IO",
        "unp": "IO",
        "un": "GB",
        "name": "British Indian Ocean Territory (Chagos Archipelago, Diego Garcia)",
        "short_name": "British Indian Ocean Territory",
        "rareness": 2,
        "visitors": 22
      },
      {
        "id": "CX",
        "unp": "CX",
        "un": "AU",
        "name": "Christmas Island",
        "short_name": "Christmas Island",
        "rareness": 1,
        "visitors": 7
      },
      {
        "id": "CC",
        "unp": "CC",
        "un": "AU",
        "name": "Cocos (Keeling) Islands",
        "short_name": "Cocos (Keeling) Islands",
        "rareness": 1,
        "visitors": 7
      },
      {
        "id": "KM",
        "unp": "KM",
        "un": "KM",
        "name": "Comoros (Anjouan, Grand Comoro, Moheli)",
        "short_name": "Comoros",
        "rareness": 2,
        "visitors": 34
      },
      {
        "id": "IN-LD",
        "unp": "IN",
        "un": "IN",
        "name": "Lakshadweep",
        "short_name": "Lakshadweep",
        "rareness": 1,
        "visitors": 11
      },
      {
        "id": "MG",
        "unp": "MG",
        "un": "MG",
        "name": "Madagascar",
        "short_name": "Madagascar",
        "rareness": 4,
        "visitors": 149
      },
      {
        "id": "MV",
        "unp": "MV",
        "un": "MV",
        "name": "Maldives",
        "short_name": "Maldives",
        "rareness": 5,
        "visitors": 575
      },
      {
        "id": "MU:0",
        "unp": "MU",
        "un": "MU",
        "name": "Mauritius & Dependencies (Agalega, St. Brandon)",
        "short_name": "Mauritius",
        "rareness": 5,
        "visitors": 455
      },
      {
        "id": "YT",
        "unp": "YT",
        "un": "FR",
        "name": "Mayotte (Dzaoudzi)",
        "short_name": "Mayotte",
        "rareness": 2,
        "visitors": 19
      },
      {
        "id": "RE",
        "unp": "RE",
        "un": "FR",
        "name": "Reunion",
        "short_name": "Reunion",
        "rareness": 4,
        "visitors": 150
      },
      {
        "id": "MU-RO",
        "unp": "MU",
        "un": "MU",
        "name": "Rodrigues Island",
        "short_name": "Rodrigues Island",
        "rareness": 1,
        "visitors": 13
      },
      {
        "id": "SC:0",
        "unp": "SC",
        "un": "SC",
        "name": "Seychelles",
        "short_name": "Seychelles",
        "rareness": 4,
        "visitors": 244
      },
      {
        "id": "YE-SU",
        "unp": "YE",
        "un": "YE",
        "name": "Socotra",
        "short_name": "Socotra",
        "rareness": 1,
        "visitors": 16
      },
      {
        "id": "SC:2",
        "unp": "SC",
        "un": "SC",
        "name": "Zil Elwannyen Sesel (Aldabra, Amirante Islands, Farquhar)",
        "short_name": "Zil Elwannyen Sesel",
        "rareness": 1,
        "visitors": 3
      }
    ]
  },
  {
    "reg": "ASI",
    "region": "Asia",
    "total": 52,
    "db": [
      {
        "id": "XA",
        "unp": "XA",
        "un": "GE",
        "name": "Abkhazia",
        "short_name": "Abkhazia",
        "rareness": 5,
        "visitors": 433
      },
      {
        "id": "AF",
        "unp": "AF",
        "un": "AF",
        "name": "Afghanistan",
        "short_name": "Afghanistan",
        "rareness": 4,
        "visitors": 143
      },
      {
        "id": "AM",
        "unp": "AM",
        "un": "AM",
        "name": "Armenia",
        "short_name": "Armenia",
        "rareness": 6,
        "visitors": 911
      },
      {
        "id": "AZ:0",
        "unp": "AZ",
        "un": "AZ",
        "name": "Azerbaijan",
        "short_name": "Azerbaijan",
        "rareness": 6,
        "visitors": 690
      },
      {
        "id": "BD",
        "unp": "BD",
        "un": "BD",
        "name": "Bangladesh",
        "short_name": "Bangladesh",
        "rareness": 4,
        "visitors": 255
      },
      {
        "id": "BT",
        "unp": "BT",
        "un": "BT",
        "name": "Bhutan",
        "short_name": "Bhutan",
        "rareness": 4,
        "visitors": 113
      },
      {
        "id": "BN",
        "unp": "BN",
        "un": "BN",
        "name": "Brunei",
        "short_name": "Brunei",
        "rareness": 4,
        "visitors": 255
      },
      {
        "id": "KH",
        "unp": "KH",
        "un": "KH",
        "name": "Cambodia",
        "short_name": "Cambodia",
        "rareness": 6,
        "visitors": 1468
      },
      {
        "id": "CN:0",
        "unp": "CN",
        "un": "CN",
        "name": "China, People’s Republic",
        "short_name": "China",
        "rareness": 7,
        "visitors": 3992
      },
      {
        "id": "GE",
        "unp": "GE",
        "un": "GE",
        "name": "Georgia",
        "short_name": "Georgia",
        "rareness": 6,
        "visitors": 1498
      },
      {
        "id": "CN-HI",
        "unp": "CN",
        "un": "CN",
        "name": "Hainan Island",
        "short_name": "Hainan Island",
        "rareness": 5,
        "visitors": 394
      },
      {
        "id": "HK",
        "unp": "HK",
        "un": "CN",
        "name": "Hong Kong",
        "short_name": "Hong Kong",
        "rareness": 7,
        "visitors": 3194
      },
      {
        "id": "IN:0",
        "unp": "IN",
        "un": "IN",
        "name": "India",
        "short_name": "India",
        "rareness": 7,
        "visitors": 2682
      },
      {
        "id": "ID-JW",
        "unp": "ID",
        "un": "ID",
        "name": "Indonesia (Java)",
        "short_name": "Indonesia",
        "rareness": 6,
        "visitors": 1135
      },
      {
        "id": "JP:0",
        "unp": "JP",
        "un": "JP",
        "name": "Japan",
        "short_name": "Japan",
        "rareness": 7,
        "visitors": 4520
      },
      {
        "id": "KR-49",
        "unp": "KR",
        "un": "KR",
        "name": "Jeju Island (South Korea)",
        "short_name": "Jeju Island",
        "rareness": 5,
        "visitors": 511
      },
      {
        "id": "ID-KA",
        "unp": "ID",
        "un": "ID",
        "name": "Kalimantan (Indonesian Borneo)",
        "short_name": "Kalimantan",
        "rareness": 4,
        "visitors": 120
      },
      {
        "id": "XJ",
        "unp": "ZZ",
        "un": "ZZ",
        "name": "Kashmir",
        "short_name": "Kashmir",
        "rareness": 5,
        "visitors": 324
      },
      {
        "id": "KZ",
        "unp": "KZ",
        "un": "KZ",
        "name": "Kazakhstan",
        "short_name": "Kazakhstan",
        "rareness": 6,
        "visitors": 894
      },
      {
        "id": "KP",
        "unp": "KP",
        "un": "KP",
        "name": "Korea, North",
        "short_name": "North Korea",
        "rareness": 3,
        "visitors": 89
      },
      {
        "id": "KR:0",
        "unp": "KR",
        "un": "KR",
        "name": "Korea, South",
        "short_name": "South Korea",
        "rareness": 7,
        "visitors": 2657
      },
      {
        "id": "KG",
        "unp": "KG",
        "un": "KG",
        "name": "Kyrgyzstan",
        "short_name": "Kyrgyzstan",
        "rareness": 5,
        "visitors": 475
      },
      {
        "id": "LA",
        "unp": "LA",
        "un": "LA",
        "name": "Laos",
        "short_name": "Laos",
        "rareness": 5,
        "visitors": 602
      },
      {
        "id": "ID-NU",
        "unp": "ID",
        "un": "ID",
        "name": "Lesser Sunda Islands (Bali, Timor, Indonesia)",
        "short_name": "Lesser Sunda Islands",
        "rareness": 6,
        "visitors": 1986
      },
      {
        "id": "MO",
        "unp": "MO",
        "un": "CN",
        "name": "Macau",
        "short_name": "Macau",
        "rareness": 6,
        "visitors": 1213
      },
      {
        "id": "MY:0",
        "unp": "MY",
        "un": "MY",
        "name": "Malaysia",
        "short_name": "Malaysia",
        "rareness": 7,
        "visitors": 2891
      },
      {
        "id": "ID-ML",
        "unp": "ID",
        "un": "ID",
        "name": "Maluku Islands",
        "short_name": "Maluku Islands",
        "rareness": 2,
        "visitors": 39
      },
      {
        "id": "MN",
        "unp": "MN",
        "un": "MN",
        "name": "Mongolia, Republic",
        "short_name": "Mongolia, Republic",
        "rareness": 4,
        "visitors": 280
      },
      {
        "id": "MM",
        "unp": "MM",
        "un": "MM",
        "name": "Myanmar (Burma)",
        "short_name": "Myanmar",
        "rareness": 5,
        "visitors": 469
      },
      {
        "id": "AZ-NX",
        "unp": "AZ",
        "un": "AZ",
        "name": "Nakhchivan",
        "short_name": "Nakhchivan",
        "rareness": 2,
        "visitors": 24
      },
      {
        "id": "NP",
        "unp": "NP",
        "un": "NP",
        "name": "Nepal",
        "short_name": "Nepal",
        "rareness": 5,
        "visitors": 616
      },
      {
        "id": "PK:0",
        "unp": "PK",
        "un": "PK",
        "name": "Pakistan",
        "short_name": "Pakistan",
        "rareness": 5,
        "visitors": 350
      },
      {
        "id": "ID-PP",
        "unp": "ID",
        "un": "ID",
        "name": "Papua (Irian Jaya)",
        "short_name": "Papua",
        "rareness": 2,
        "visitors": 38
      },
      {
        "id": "PH",
        "unp": "PH",
        "un": "PH",
        "name": "Philippines",
        "short_name": "Philippines",
        "rareness": 6,
        "visitors": 1506
      },
      {
        "id": "RU:A",
        "unp": "RU",
        "un": "RU",
        "name": "Russia in Asia (incl. Siberia)",
        "short_name": "Russia in Asia",
        "rareness": 6,
        "visitors": 1188
      },
      {
        "id": "MY:SA",
        "unp": "MY",
        "un": "MY",
        "name": "Sabah (North Borneo)",
        "short_name": "Sabah",
        "rareness": 5,
        "visitors": 397
      },
      {
        "id": "MY-13",
        "unp": "MY",
        "un": "MY",
        "name": "Sarawak",
        "short_name": "Sarawak",
        "rareness": 4,
        "visitors": 263
      },
      {
        "id": "IN-SK",
        "unp": "IN",
        "un": "IN",
        "name": "Sikkim",
        "short_name": "Sikkim",
        "rareness": 4,
        "visitors": 113
      },
      {
        "id": "SG",
        "unp": "SG",
        "un": "SG",
        "name": "Singapore",
        "short_name": "Singapore",
        "rareness": 7,
        "visitors": 3703
      },
      {
        "id": "XO",
        "unp": "XO",
        "un": "GE",
        "name": "South Ossetia",
        "short_name": "South Ossetia",
        "rareness": 2,
        "visitors": 41
      },
      {
        "id": "LK",
        "unp": "LK",
        "un": "LK",
        "name": "Sri Lanka (Ceylon)",
        "short_name": "Sri Lanka",
        "rareness": 6,
        "visitors": 888
      },
      {
        "id": "ID-SL",
        "unp": "ID",
        "un": "ID",
        "name": "Sulawesi (Celebes, Indonesia)",
        "short_name": "Sulawesi",
        "rareness": 4,
        "visitors": 142
      },
      {
        "id": "ID-SM",
        "unp": "ID",
        "un": "ID",
        "name": "Sumatra (Indonesia)",
        "short_name": "Sumatra",
        "rareness": 5,
        "visitors": 526
      },
      {
        "id": "TW",
        "unp": "TW",
        "un": "CN",
        "name": "Taiwan. R.O.C.",
        "short_name": "Taiwan",
        "rareness": 6,
        "visitors": 1777
      },
      {
        "id": "TJ",
        "unp": "TJ",
        "un": "TJ",
        "name": "Tajikistan",
        "short_name": "Tajikistan",
        "rareness": 4,
        "visitors": 214
      },
      {
        "id": "TH",
        "unp": "TH",
        "un": "TH",
        "name": "Thailand",
        "short_name": "Thailand",
        "rareness": 7,
        "visitors": 4506
      },
      {
        "id": "CN-XZ",
        "unp": "CN",
        "un": "CN",
        "name": "Tibet",
        "short_name": "Tibet",
        "rareness": 4,
        "visitors": 133
      },
      {
        "id": "TL",
        "unp": "TL",
        "un": "TL",
        "name": "Timor-Leste",
        "short_name": "Timor-Leste",
        "rareness": 3,
        "visitors": 59
      },
      {
        "id": "TR:A",
        "unp": "TR",
        "un": "TR",
        "name": "Turkey in Asia (Anatolia, Ankara, Izmir)",
        "short_name": "Turkey in Asia",
        "rareness": 7,
        "visitors": 4590
      },
      {
        "id": "TM",
        "unp": "TM",
        "un": "TM",
        "name": "Turkmenistan",
        "short_name": "Turkmenistan",
        "rareness": 4,
        "visitors": 117
      },
      {
        "id": "UZ",
        "unp": "UZ",
        "un": "UZ",
        "name": "Uzbekistan",
        "short_name": "Uzbekistan",
        "rareness": 5,
        "visitors": 625
      },
      {
        "id": "VN",
        "unp": "VN",
        "un": "VN",
        "name": "Vietnam",
        "short_name": "Vietnam",
        "rareness": 7,
        "visitors": 2547
      }
    ]
  }
];
